const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_8[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_8[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_8[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_8[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_8[0].TextField8[2]"
    }, 
    docLicenseNo: {
        value : "",
        dbqName: "F[0].Page_8[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_8[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B1[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[2]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B2[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[14]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B3[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[12]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B4[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[13]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B5[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[11]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B6[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[8]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B7[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[10]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B8[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[9]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B9[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[3]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B11[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[4]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B10[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[7]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B13[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[5]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].B12[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[6]",
        },        
        {
            type: "text",
            dbqName: "F[0].Page_2[0].diagnosis1[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].diagnosis2[0]",
            dateDbqName: "F[0].Page_2[0].Dateofdiagnosis5[1]",
        },        
    ]

}

export default ssn ;